var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-sm btn-warning",attrs:{"href":_vm.link}},[_vm._v("Editar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }